
<template>
  <div
    class="aspect-square shadow-md bg-white rounded-lg flex justify-center items-center"
  >
    <LoadingSpinner />
  </div>
</template>
